import { render, staticRenderFns } from "./BRPrevLavDin.vue?vue&type=template&id=6f104e34&"
import script from "./BRPrevLavDin.vue?vue&type=script&lang=js&"
export * from "./BRPrevLavDin.vue?vue&type=script&lang=js&"
import style0 from "./BRPrevLavDin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports